module.exports = __webpack_public_path__ + "static/media/putty_knife.11eea9d6.svg";